import {
  Alarm,
  AuditLog,
  Auth,
  Backup,
  Config,
  Contact,
  ContactGroup,
  Device,
  Event,
  EventMapping,
  FeatureFlags,
  Location,
  Notification,
  Room,
  Scanner,
  User,
  i18n,
} from '@evac/shared'
import { createI18n } from 'vue-i18n'

export default createI18n({
  legacy: false,
  locale: 'cs',
  fallbackLocale: 'en',
  messages: mergeMessages(
    i18n,
    Auth.i18n,
    Event.i18n,
    Config.i18n,
    Backup.i18n,
    AuditLog.i18n,
    FeatureFlags.i18n,
    Alarm.i18n,
    Device.i18n,
    Notification.i18n,
    Location.i18n,
    Room.i18n,
    Scanner.i18n,
    Contact.i18n,
    ContactGroup.i18n,
    EventMapping.i18n,
    User.i18n
  ),
})

function mergeMessages(...sources: Record<string, any>[]) {
  const output: Record<string, any> = {}

  // Only first level is merged, deeper levels are replaced
  for (const source of sources) {
    for (const [key, value] of Object.entries(structuredClone(source))) {
      output[key] = { ...(output[key] ?? null), ...value }
    }
  }

  return output
}
